<i18n>
{
  "en": {
    "title": "Order Info",
    "pleaseEnterCompanyName": "Please enter company name"
  },
  "zh-tw": {
    "title": "訂單資訊",
    "pleaseEnterCompanyName": "請輸入收據抬頭"
  }
}
</i18n>

<template>
  <prompt
    :title="$t(`title`)"
    :label="$t(`paymentMethod`)"
    :defaultValue="$t(`pleaseEnterCompanyName`)"
    placeholder="ex. 悠遊餐飲國際有限公司"
    @confirm="v => setOrderParams({ invoiceTitle: v })" />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Prompt from '@/common/components/Prompt'

export default {
  computed: {
    ...mapState(['invoiceTitle'])
  },
  methods: {
    ...mapActions(['setOrderParams'])
  },
  components: { Prompt }
}
</script>
